// TES-1019 (Emelie, point 2) — "saknat underlag": what the doctor is still
// waiting for before the note can be complete, derived only from the open
// completion checklist and its blood test. Nothing is inferred: a row is
// listed because the checklist says it is not done.
//
// Pure on purpose: no React, no path aliases. The unit tests in
// `apps/admin/test` run it with plain `node --test`.
import {
  BLOOD_TEST_STATUS_LABELS,
  FOLLOW_UP_ITEM_LABELS,
  type ClinicianMedicalEvidence,
} from "@care-by-ella/contracts";

// Her F-07 reopened as a completion, by its readable name.
const TRANSFER_COMPLETION_MISSING =
  "Läkemedel och behandlingsunderlag är inte kompletterat";

export function missingBasis(
  evidence: Pick<
    ClinicianMedicalEvidence,
    "active" | "tasks" | "customTasks" | "transferCompletion" | "bloodTest"
  > | null,
): string[] {
  if (!evidence?.active) return [];
  const out: string[] = [];
  for (const t of evidence.tasks) {
    if (t.locked || t.status !== "missing") continue;
    out.push(FOLLOW_UP_ITEM_LABELS[t.key].sv);
  }
  if (evidence.transferCompletion?.status === "missing") {
    out.push(TRANSFER_COMPLETION_MISSING);
  }
  for (const c of evidence.customTasks ?? []) {
    if (c.status === "missing") out.push(`${c.heading} – inte klart`);
  }
  // The sample is given but its result not yet in, or in but not reviewed:
  // the tasks above are done, and the doctor is still waiting.
  const blood = evidence.bloodTest;
  if (
    blood &&
    (blood.status === "sample_reported" || blood.status === "result_registered")
  ) {
    out.push(`Blodprov: ${BLOOD_TEST_STATUS_LABELS[blood.status]}`);
  }
  return out;
}
